module.exports = __webpack_public_path__ + "img/jjiaoshi_renyuan.c45019a5.png";